export default function WhatIsForeclosureSection() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6">
            Understanding Foreclosure in Texas
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Knowledge is power when it comes to avoiding foreclosure. Here's what every El Paso homeowner needs to know about the foreclosure process and how to stop it.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start mb-16">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/5837a2014997c1b16cecd1485db9d165.jpg" 
              alt="Understanding foreclosure process in Texas" 
              className="w-full h-auto rounded-2xl shadow-xl"
            />
          </div>

          <div>
            <h3 className="text-3xl font-black text-gray-900 mb-6">What Is Foreclosure?</h3>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Foreclosure is a legal process where your mortgage lender takes possession of your property because you've fallen behind on mortgage payments. In Texas, foreclosures are typically non-judicial, meaning they don't require court proceedings and can happen very quickly.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              When you miss mortgage payments, your lender will send notices demanding payment. If you don't catch up or make arrangements, they can schedule a foreclosure sale. In Texas, this sale happens at the county courthouse on the first Tuesday of the month, and your home is sold to the highest bidder.
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              The good news is that you have options to avoid foreclosure before the sale date. Selling your house for cash to a reputable buyer like T-Rex Real Estate is often the fastest and most effective way to stop foreclosure and protect your credit.
            </p>

            <div className="bg-white p-6 rounded-xl shadow-lg border-l-4 border-red-600">
              <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                <i className="ri-alert-fill text-red-600 mr-3 text-2xl"></i>
                Texas Foreclosure Timeline
              </h4>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-600 mr-3 mt-1 flex-shrink-0"></i>
                  <span className="text-base text-gray-700"><strong>Day 1:</strong> First missed payment</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-600 mr-3 mt-1 flex-shrink-0"></i>
                  <span className="text-base text-gray-700"><strong>Day 120:</strong> Notice of Default sent</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-600 mr-3 mt-1 flex-shrink-0"></i>
                  <span className="text-base text-gray-700"><strong>Day 141:</strong> Notice of Trustee Sale posted</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-600 mr-3 mt-1 flex-shrink-0"></i>
                  <span className="text-base text-gray-700"><strong>Day 162:</strong> Foreclosure sale at courthouse</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
          <h3 className="text-3xl font-black text-gray-900 mb-8 text-center">Types of Foreclosure in Texas</h3>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="border-2 border-gray-200 rounded-xl p-6 hover:border-teal-600 transition-colors">
              <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-file-text-fill text-2xl text-teal-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">Non-Judicial Foreclosure</h4>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                Most common in Texas. The lender can foreclose without going to court if your deed of trust includes a "power of sale" clause. This process is faster and less expensive for lenders, which is why it's critical to act quickly to avoid foreclosure.
              </p>
              <p className="text-sm text-gray-600 italic">
                Timeline: As fast as 41 days from first notice to sale
              </p>
            </div>

            <div className="border-2 border-gray-200 rounded-xl p-6 hover:border-teal-600 transition-colors">
              <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-government-fill text-2xl text-teal-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">Judicial Foreclosure</h4>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                Less common in Texas. The lender must file a lawsuit and obtain a court order to foreclose. This process takes longer but gives homeowners more time to find solutions to avoid foreclosure, such as selling to a cash buyer.
              </p>
              <p className="text-sm text-gray-600 italic">
                Timeline: 6-12 months depending on court schedule
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}